export default function ArrowUpIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.00008 4.66675L12.6189 9.66675H3.38128L8.00008 4.66675Z" fill="currentColor" />
    </svg>
  );
}
